"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React, { Component } from "react";
import { observable, computed, runInAction } from "mobx";
import { observer } from "mobx-react";
import Tooltip from "../../pieces/Tooltip/Tooltip";
import { AnimationDuration } from "../../../styles/Animations";
import { copyToClipboard } from "../../../utils/copyToClipboard";
let CopyToClipboard = class extends Component {
  constructor() {
    super(...arguments);
    this.showTooltip = this.props.showTooltipOnCopy ? false : void 0;
    this.showOnCopiedTooltip = false;
    this.showOnErrorTooltip = false;
    this.handleCopy = () => {
      clearTimeout(this.waitTimer);
      clearTimeout(this.hideTimer);
      this.showTooltip = true;
      this.showOnCopiedTooltip = true;
      copyToClipboard(this.props.value, () => this.showOnErrorTooltip = true);
      this.waitTimer = window.setTimeout(() => {
        runInAction(() => {
          this.showTooltip = this.props.showTooltipOnCopy ? false : void 0;
          this.hideTimer = window.setTimeout(() => {
            runInAction(() => {
              this.showOnCopiedTooltip = false;
              this.showOnErrorTooltip = false;
            });
          }, AnimationDuration.Medium);
        });
      }, 1200);
    };
  }
  componentWillUnmount() {
    clearTimeout(this.waitTimer);
    clearTimeout(this.hideTimer);
  }
  get tooltip() {
    if (this.showOnErrorTooltip) {
      return this.props.tooltipOnError;
    }
    if (this.showOnCopiedTooltip) {
      return this.props.tooltipOnCopied;
    }
    return this.props.tooltip;
  }
  render() {
    return /* @__PURE__ */ React.createElement(Tooltip, __spreadValues({ show: this.showTooltip }, this.tooltip), this.props.children({ onCopy: this.handleCopy }));
  }
};
CopyToClipboard.defaultProps = {
  tooltip: { content: "Copy" },
  tooltipOnCopied: { content: "Copied" },
  tooltipOnError: { content: "Could not copy" }
};
__decorateClass([
  observable.ref
], CopyToClipboard.prototype, "showTooltip", 2);
__decorateClass([
  observable.ref
], CopyToClipboard.prototype, "showOnCopiedTooltip", 2);
__decorateClass([
  observable.ref
], CopyToClipboard.prototype, "showOnErrorTooltip", 2);
__decorateClass([
  computed
], CopyToClipboard.prototype, "tooltip", 1);
CopyToClipboard = __decorateClass([
  observer
], CopyToClipboard);
export default CopyToClipboard;
